import { render } from "./RequestVerifyEmail.vue?vue&type=template&id=12c13915&scoped=true"
import script from "./RequestVerifyEmail.vue?vue&type=script&lang=js"
export * from "./RequestVerifyEmail.vue?vue&type=script&lang=js"

import "./RequestVerifyEmail.vue?vue&type=style&index=0&id=12c13915&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Mudassir\\Retrocausal\\portal_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12c13915"]])

export default __exports__